module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Sports/color/new_basketball-ee6de2eea829475eb98a69465b72a002.svg";